import {useCallback, useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'
import {
	ROLE_FIELD_MANAGER,
	ROLE_TIMER_MANAGER,
	ROLE_COMPETITION_MANAGER,
} from 'shared/constant/lookup/role'

const useGetAccountList = ({enableSearchGlobally = false} = {}) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const [userRole] = useRoleCookie()

	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const status = searchParams.get('status')
	const franchise = searchParams.get('franchise')
	const qualification = searchParams.get('qualification')
	const sortBy = searchParams.get('sortBy')
	const sortDirection = searchParams.get('sortDirection')

	const [, setAlert] = useAlertModalAtom()

	const refetch = useCallback(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/account/list?page=${page || 1}`

		if (search) url += `&search=${search}`
		if (status && status !== 'all') url += `&status=${status}`
		if (qualification && qualification !== 'all')
			url += `&qualification_idx=${qualification}`
		if (franchise && franchise !== 'all') url += `&franchise_idx=${franchise}`
		if (sortBy) url += `&sortBy=${sortBy}`
		if (sortDirection) url += `&sortDirection=${sortDirection}`
		if (enableSearchGlobally && search) {
			const isManagerRole =
				Number(userRole) === ROLE_FIELD_MANAGER ||
				Number(userRole) === ROLE_TIMER_MANAGER ||
				Number(userRole) === ROLE_COMPETITION_MANAGER
			if (isManagerRole) url += `&search_globally=true`
		}

		fetchRequest('GET', url)
	}, [
		page,
		search,
		status,
		franchise,
		qualification,
		sortBy,
		sortDirection,
		userRole,
		enableSearchGlobally,
	])

	useEffect(() => {
		refetch()
	}, [refetch])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			default:
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading, refetch]
}

export default useGetAccountList
